import { AfterViewInit, Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router, RouterLink } from '@angular/router';
import { BehaviorSubject, debounceTime, distinctUntilChanged, filter, map, Observable, Subject, switchMap, tap } from 'rxjs';
import { MainHeaderComponent } from '../../shared/main-header/main-header.component';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { LibraryObjectsSerive } from '../../../services/library_objects.service';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatPaginatorIntlCro } from './paginator-intl';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { ApiRequestParams } from '../../../services/client_library_objects.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { FilePickerSheetComponent } from '../../shared/file-picker-sheet/file-picker-sheet.component';
import { MatChip, MatChipListbox } from '@angular/material/chips';
import { ClientsService } from '../../../services/clients.service';


export interface FilterOption {
  id: number;
  key: string;
  displayName: string;
  selected: boolean;
  isLoading: boolean;
  hasSubFilter: boolean;
  subFilterOptions: { id: number | boolean, name: string }[];
  subFilterValue: number | string | boolean | null;
}

@Component({
  selector: 'app-list-library-objects',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,

    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatChipListbox,
    MatChip,
    MainHeaderComponent],
  providers: [{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlCro }],
  templateUrl: './list-library-objects.component.html',
  styleUrls: ['./list-library-objects.component.scss']
})
export class ListLibraryObjectsComponent implements OnInit, AfterViewInit {
  // --- VISTAS Y REFERENCIAS ---
  @ViewChild('searchInput') searchInput!: ElementRef;
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;


  public requestParams: ApiRequestParams = { page: 1, limit: 20 };
  public filters: FilterOption[] = [

    {
      id: 1, key: 'brand', displayName: 'Marca', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 2, key: 'category', displayName: 'Categorías', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 3, key: 'company', displayName: 'Compañía', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 4, key: 'flavor', displayName: 'Sabores', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 6, key: 'multi_package', displayName: 'Multi-empaques', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 7, key: 'package', displayName: 'Empaques', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 8, key: 'shape', displayName: 'Formas', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 9, key: 'size', displayName: 'Tamaño', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 12, key: 'line', displayName: 'Líneas', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 5, key: 'other', displayName: 'Otros', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 20, key: 'client_id', displayName: 'Cliente', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [], subFilterValue: null
    },
    {
      id: 21, key: 'is_active', displayName: 'Activo', selected: false, isLoading: false,
      hasSubFilter: true, subFilterOptions: [{ id: true, name: 'Activos' }, { id: false, name: 'Inactivos' }], subFilterValue: null
    }

  ];

  public isLoading = true;
  public totalItems = 0;
  public searchValue: string = '';
  public apiResponse$!: Observable<any>;
  private semanticSearch$ = new Subject<string>();
  private firstLoad = true;
  semanticResults: any[] = [];
  isSemanticLoading = false;
  showSemanticResults = false;


  constructor(
    private productService: LibraryObjectsSerive,
    private clientService: ClientsService,
    private router: Router,
    private route: ActivatedRoute,
    private _bottomSheet: MatBottomSheet
  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      if (this.firstLoad && params['is_active'] === undefined) {
        this.firstLoad = false;

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            page: 1,
            limit: 20,
            sortBy: 'created_at:DESC', 
            ...params,
            is_active: true },
          replaceUrl: true,
        });
        return;
      }

      this.syncUiWithUrlParams(params);
      this.fetchProducts(params);
    });

    this.semanticSearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(q => q.length >= 2),
        switchMap(query => {
          // console.log('Enviando a backend:', query);
          this.isSemanticLoading = true;
          const activeFilter = this.activeFilter;

          let isActiveValue = true;

          if (activeFilter.selected && activeFilter.subFilterValue !== null) {
            isActiveValue = activeFilter.subFilterValue as boolean;
          }
          return this.productService.searchSemantic({
            text_query: query,
            filters: {
              is_active: isActiveValue
            }
          });
        })
      )
      .subscribe({
        next: results => {
          // console.log('Respuesta backend:', results);
          
          this.semanticResults = results.map((item: any) => ({
            ...item,
            groupedAttributes: this.groupAttributes(item.library_attributes)
          }));
          this.showSemanticResults = results.length > 0;
          this.isSemanticLoading = false;
        },
        error: () => {
          this.isSemanticLoading = false;
        }
      });
  }


  // --- LÓGICA DE BÚSQUEDA SEMÁNTICA ---

  onSemanticSearch(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (!value.trim()) {
      this.closeSemanticResults();
      return;
    }

    this.semanticSearch$.next(value);
  }

  onSemanticSelect(item: any): void {
    console.log('Selected semantic item:', item);
    this.showSemanticResults = false;
    this.semanticResults = [];
    this.searchValue = item.name;
    this.buildAndNavigate(true);
  }

  private closeSemanticResults(): void {
    this.showSemanticResults = false;
    this.semanticResults = [];
    this.isSemanticLoading = false;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (!target.closest('.semantic-results') && !target.closest('.semantic-search-input')) {
      this.showSemanticResults = false;
    }
  }

  ngAfterViewInit(): void {
    if (this.searchInput && this.searchInput.nativeElement) {
      setTimeout(() => { this.searchInput.nativeElement.focus(); }, 0);
    }
  }


  get attributeFilters(): FilterOption[] {
    return this.filters.filter(f => f.key !== 'client_id' && f.key !== 'is_active');
  }

  get clientFilter(): FilterOption {
    return this.filters.find(f => f.key === 'client_id')!;
  }

  get activeFilter(): FilterOption {
    return this.filters.find(f => f.key === 'is_active')!;
  }



  get selectedFiltersCount(): number {
    return this.filters.filter(f => f.selected && f.subFilterValue !== null).length;
  }

  public onFilterChange(filter: FilterOption): void {
    console.log('onFilterChange', filter);

    if (filter.selected) {
      this.fetchFilterOptions(filter);
    } else {
      filter.subFilterValue = null;
      this.buildAndNavigate();
    }
  }

  private fetchFilterOptions(filter: FilterOption): void {

    if (!filter.hasSubFilter || filter.subFilterOptions.length > 0) return;
    filter.isLoading = true;

    let serviceCall$: Observable<any[]>;
    let mapper: (item: any) => { id: number; name: string };

    if (filter.key === 'client_id') {
      serviceCall$ = this.clientService
        .loadClients()
        .pipe(map(res => res.data));

      mapper = (item) => ({
        id: item.client_id,
        name: item.name
      });

    } else {
      serviceCall$ = this.productService.getAttributesByType(filter.key);

      mapper = (item) => ({
        id: item.library_attribute_id,
        name: item.name
      });
    }

    serviceCall$.subscribe({
      next: items => {
        filter.subFilterOptions = items.map(mapper);
        filter.isLoading = false;
      },
      error: err => {
        console.error(`Error cargando opciones para '${filter.displayName}':`, err);
        filter.isLoading = false;
      }
    });
  }

  sendObjects(lobject: any) {
    this.router.navigate(['/library-objects', lobject.library_object_id]);
  }
  public onSubFilterSelect(): void {
    console.log('¡onSubFilterSelect SÍ se está disparando!');
    this.buildAndNavigate();
    if (this.menuTrigger) {
      this.menuTrigger.closeMenu();
    }
  }

  // --- LÓGICA DE BÚSQUEDA Y PAGINACIÓN ---

  public onSearch(): void {
    this.closeSemanticResults();
    this.buildAndNavigate(true);
  }

  public clearSearch(): void {
    this.searchValue = '';
    this.onSearch();
  }

  public handlePageEvent(event: PageEvent): void {
    this.requestParams.page = event.pageIndex + 1;
    this.requestParams.limit = event.pageSize;
    this.buildAndNavigate();
  }
  selectedFile: File | null = null;

  onUpload(): void {
    if (!this.selectedFile) {
      console.error('No hay archivo seleccionado para subir.');
      return;
    }


  }
  // --- MÉTODOS CENTRALES ---

  private buildAndNavigate(resetPage: boolean = false): void {
    const queryParams: any = {};

    queryParams.page = resetPage ? 1 : (this.requestParams.page || 1);
    queryParams.limit = this.requestParams.limit || 20;
    queryParams.sortBy = this.requestParams.sortBy || ['created_at:DESC'];

    if (typeof this.searchValue === 'string' && this.searchValue.trim() !== '') {
      const value = this.searchValue.trim();

      const isNumeric = /^[0-9]+$/.test(value);

      if (isNumeric) {
        queryParams['library_object_id'] = `${value}`;
      } else {
        queryParams.search = value;
      }
    }

    this.filters.forEach(filter => {
      if (filter.selected && filter.subFilterValue !== null) {
        queryParams[filter.key] = filter.subFilterValue;
      }
    });

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
    });
  }

  private syncUiWithUrlParams(params: Params): void {

  this.searchValue = params['search'] || '';

  this.requestParams.page = params['page'] ? +params['page'] : 1;
  this.requestParams.limit = params['limit'] ? +params['limit'] : 20;

  this.filters.forEach(filter => {

    if (params[filter.key] !== undefined) {

      filter.selected = true;

      if (filter.key === 'is_active') {
        filter.subFilterValue = params['is_active'] === 'true';
      } else {
        filter.subFilterValue =
          !isNaN(Number(params[filter.key]))
          ? +params[filter.key]
          : params[filter.key];
      }

      this.fetchFilterOptions(filter);

    } else {

      filter.selected = false;
      filter.subFilterValue = null;

    }

  });
}


  private fetchProducts(params: Params): void {
    this.isLoading = true;
    this.apiResponse$ = this.productService.getLibraryObject(params).pipe(
      tap(response => {
        console.log('Respuesta de productos:', response);
        this.totalItems = response.meta.totalItems;
        this.isLoading = false;
      })
    );
  }


  // Propiedades para manejar el estado de la UI
  isLoading2 = false;
  isError = false;
  uploadMessage = '';
  @ViewChild('fileInput') fileInput!: ElementRef;

  openFilePicker(): void {
    this.fileInput.nativeElement.click();
  }
  private getCurrentRouteParamsOrFilters(): Params {
    return {
      page: 1,
      limit: 20,
    };
  }
  onFileSelectedAndUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) {
      return;
    }
    const fileToUpload: File = input.files[0];
    const uploadState$ = new BehaviorSubject<{ status: string; data?: any; error?: any }>({
      status: 'loading'
    });





    const sheetRef = this._bottomSheet.open(FilePickerSheetComponent, {
      data: {
        fileName: fileToUpload.name,
        uploadState$: uploadState$.asObservable()
      },
      disableClose: true,
    });

    sheetRef.afterDismissed().subscribe(resultado => {
      console.log('res', resultado);

      if (resultado && resultado.changes) {

        const currentParams = this.getCurrentRouteParamsOrFilters();
        this.fetchProducts(currentParams);

      }
    });






    this.productService.uploadCsv(fileToUpload).subscribe({
      next: (response) => {
        uploadState$.next({ status: 'success', data: response });
        uploadState$.complete();
      },
      error: (err) => {
        uploadState$.next({ status: 'error', error: err });
        uploadState$.complete();
      },
      complete: () => {
        this.fileInput.nativeElement.value = '';
      },
    });
  }

  groupAttributes(attrs: any[]) {
    if (!attrs) return [];

    const map = new Map<string, string[]>();

    attrs.forEach(attr => {
      const type = attr.library_attribute_type?.label;
      if (!type) return;

      if (!map.has(type)) {
        map.set(type, []);
      }
      map.get(type)!.push(attr.label);
    });

    return Array.from(map.entries()).map(([typeLabel, values]) => ({
      typeLabel,
      values
    }));
  }

}